export function charToInt(char: string): number {
    const code = "a".charCodeAt(0);
    return char.charCodeAt(0) - code;
}

export function intToChar(int: number): string {
    const code = "a".charCodeAt(0);
    return String.fromCharCode(code + int);
}

export function capitalizeFirst(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lowercaseFirst(string: string): string {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
